import { Typography, TypographyHTMLProps } from "@rmwc/typography"
import "@rmwc/typography/styles"
import omit from "lodash/omit"
import { styled, StyleProps, CSSFn, callCSSFn, CSS } from "../styles"

interface Props {
  // eslint-disable-next-line react/no-unused-prop-types
  css?: CSSFn
}

export type LargeTextProps = TypographyHTMLProps & Props

const LargeTextComponent = (props: LargeTextProps) => {
  const { ...rest } = omit(props, `css`)
  return <Typography {...{ use: `body1`, ...rest }} />
}

LargeTextComponent.defaultProps = {
  css: undefined,
}

export const LargeText = styled(LargeTextComponent)(
  (props: StyleProps & LargeTextProps): CSS => ({
    margin: 0,
    ...props.theme.fonts.heading,
    fontSize: props.theme.fontSize.large,
    lineHeight: 1,
    ...callCSSFn(props),
  })
)
